import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import TopUp2Icon from 'assets/img/icons/topup2.svg';
import { BodyS, DisplayM, HeadingS, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import classNames from 'classnames';
import CustomInput from 'components/CustomInput/CustomInput';
import React from 'react';
import numeral from 'numeral';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import { makeStyles } from '@material-ui/styles';
import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import TopUpValues from './subcomponents/TopUpValues';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ITopUpCardProps {
	isEmpty: boolean;
	setIsEmpty: React.Dispatch<React.SetStateAction<boolean>>;
	topupValue: number;
	setTopupValue: React.Dispatch<React.SetStateAction<number>>;
	customTopupValue: number;
	selectedNumbers: types.topUp.INumber[];
	totalAmount: string | number;
	closeEdit: () => void;
	setCustomTopupValue: (value: number) => void;
	checkTopupValue: (value: string, setIsEmpty: Function, setValue: (value: number) => void) => void;
}

const TopUpCard = ({
	totalAmount,
	isEmpty,
	topupValue,
	setTopupValue,
	customTopupValue,
	selectedNumbers,
	setIsEmpty,
	closeEdit,
	setCustomTopupValue,
	checkTopupValue,
}: ITopUpCardProps) => {
	const classes = useStyles();

	return (
		<div className={classes.topupCard}>
			<Card>
				<CardBody>
					<GridContainer justify="space-between" className={classes.headerContainer}>
						<div className={classes.topupCardHeader}>
							<HeadingSBold inline disableMargin>
								{translate('payments.topup.card.header')}
							</HeadingSBold>
							<span>
								<CustomTooltip placement="top" size="sm">
									{translate('payments.topup.card.tip')}
								</CustomTooltip>
							</span>
						</div>

						<GridItem xs={12} sm={6} md={4} lg={2}>
							<img className={classes.topUpCardIcon} alt="topup" src={TopUp2Icon} />
						</GridItem>
						<GridItem xs={12} sm={6} md={4} lg={4} id="topup-value">
							<TopUpValues topupValue={topupValue} setTopupValue={setTopupValue} />
						</GridItem>
						<GridItem xs={12} sm={6} md={4} lg={2} className={classes.alignRight}>
							<BodyS color="secondary-light">{translate('payments.topup.customTopupValue')}</BodyS>
							<CustomInput
								helperText={translate('topup.value.limit')}
								id="topup-value-input"
								inputProps={{
									value: isEmpty ? '' : customTopupValue,
									onChange: (event: React.FormEvent<HTMLInputElement>) => {
										const value = (event.target as HTMLInputElement).value;
										closeEdit();
										checkTopupValue(value, setIsEmpty, (value: number) => {
											setCustomTopupValue(Number(value));
											setTopupValue(Number(value));
										});
									},
								}}
								formControlProps={{
									className: classNames(classes.customTopUpInput, classes.customInput),
								}}
								variant="outlined"
							/>
						</GridItem>
						<GridItem xs={12} sm={6} md={4} lg={2} className={classes.alignRight} id="selected-numbers">
							<BodyS color="secondary-light">{translate('payments.topup.selectedNumbers')}</BodyS>
							<div className={classes.marginValue}>
								<DisplayM color="disabled-light" disableMargin>
									{String(selectedNumbers.length)}
								</DisplayM>
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={4} lg={2} className={classes.alignRight} id="total-amount">
							<BodyS color="secondary-light">{translate('payments.topup.totalAmount')}</BodyS>
							<div className={classes.marginValue}>
								<DisplayM inline>{numeral(totalAmount).format('0,0')}</DisplayM>
								<HeadingS inline> OMR</HeadingS>
							</div>
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
		</div>
	);
};

export default TopUpCard;
